module.exports = __webpack_public_path__ + "static/img/MaciunasGeorge_Letter1-to-GeorgeBrecht_winter1962-63_2_FPO.3bb6885.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/brecht/archive/MaciunasGeorge_Letter1-to-GeorgeBrecht_winter1962-63_2_FPO.jpg
// module id = j7tZ
// module chunks = 0